var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_537_12041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6783 14.4572L19.4021 14.4565C18.7717 14.4565 18.2607 14.9675 18.2607 15.5979V20.1585C18.2607 20.7887 18.7717 21.2998 19.4021 21.2998H27.4415C26.5612 23.5844 24.9181 25.4977 22.8218 26.7134L26.2498 32.6477C31.7488 29.4674 34.9998 23.8873 34.9998 17.6407C34.9998 16.7513 34.9343 16.1155 34.8032 15.3996C34.7035 14.8556 34.2313 14.4572 33.6783 14.4572Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 28.1524C13.5659 28.1524 10.1312 26.0027 8.28654 22.8218L2.35254 26.2421C5.37231 31.4758 11.0293 35.0002 17.5002 35.0002C20.6746 35.0002 23.6699 34.1455 26.2502 32.656V32.6479L22.8222 26.7136C21.2542 27.6231 19.4396 28.1524 17.5002 28.1524Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 32.6558V32.6477L22.822 26.7134C21.254 27.6228 19.4396 28.1521 17.5 28.1521V35C20.6744 35 23.6698 34.1453 26.25 32.6558Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84783 17.5002C6.84783 15.5609 7.37707 13.7466 8.28632 12.1786L2.35231 8.7583C0.854629 11.3305 0 14.3176 0 17.5002C0 20.6827 0.854629 23.6699 2.35231 26.242L8.28632 22.8217C7.37707 21.2538 6.84783 19.4395 6.84783 17.5002Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 6.84783C20.0658 6.84783 22.4224 7.75947 24.2632 9.27589C24.7173 9.64995 25.3773 9.62295 25.7932 9.20698L29.0246 5.97564C29.4965 5.50368 29.4629 4.73115 28.9588 4.29379C25.8747 1.61827 21.862 0 17.5002 0C11.0293 0 5.37231 3.5244 2.35254 8.75813L8.28654 12.1784C10.1312 8.99746 13.5659 6.84783 17.5002 6.84783Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2629 9.27589C24.717 9.64995 25.3771 9.62295 25.793 9.20698L29.0244 5.97564C29.4962 5.50368 29.4626 4.73115 28.9585 4.29379C25.8745 1.6182 21.8618 0 17.5 0V6.84783C20.0655 6.84783 22.4222 7.75947 24.2629 9.27589Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_537_12041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle2);
export default __webpack_public_path__ + "static/media/google 2.5e378d3fe8d16334b71d34ea8a6cc2b2.svg";
export { ForwardRef as ReactComponent };